let list = [];

for (let i = 0; i < 15; i++) {
    list.push({
        id: i + 1,
        name: '老王的设备',
        xlh: 'device000001',
        position: '济南市市中区厉阳大街 大厦',
        state: i < 4 ? '1' : '0',
        bindDate: '2019-12-22 12:22:22',
        remark: ' 总部餐厅的消费机'
    });
}

export default {
    list,
    total: list.length,
    pageSize: 15,
    pageNum: 1
}



// WEBPACK FOOTER //
// ./src/configure/http/mock/response/operate/grant/queryBindDevicePage.js